module.exports = "images/preloader_logo.png";